import { useLanguage } from '../../i18n/LanguageContext';
import { Languages } from 'lucide-react';

export interface LanguageToggleProps {
  className?: string;
  showLabel?: boolean;
}

function LanguageToggle({ className = '', showLabel = false }: LanguageToggleProps) {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      className={`inline-flex items-center gap-2 px-3 py-2 text-sm font-medium rounded-md transition-colors duration-150 bg-light-hover dark:bg-dark-hover text-light-text dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-border focus:outline-none focus:ring-2 focus:ring-accent-500 focus:ring-offset-2 dark:focus:ring-offset-dark-bg ${className}`}
      aria-label={`Switch to ${language === 'fr' ? 'English' : 'French'}`}
      title={`Switch to ${language === 'fr' ? 'English' : 'Francais'}`}
    >
      <Languages className="h-4 w-4" />
      <span className="uppercase font-semibold">{language}</span>
      {showLabel && (
        <span className="text-light-muted dark:text-dark-muted">
          {language === 'fr' ? 'Francais' : 'English'}
        </span>
      )}
    </button>
  );
}

export default LanguageToggle;
